var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"row py-5",attrs:{"id":"isk-app-wrapper"}},[_c('StoCscFilterGrid'),_c('StoCscResultGrid'),_c('StoCscContactGrid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }